// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { FaUserCircle } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { pdf } from "@react-pdf/renderer";
// import { saveAs } from "file-saver";
// import InternationalPDFDocument from "./InternationalPDFDocument";
// import { translateText } from "../Navbar/Navbar"; // same translator as Indiadirectory
// import { FaArrowDown } from "react-icons/fa";
// const CARDS_PER_PAGE = 16;

// const InternationalLeaders = ({ selectedLang }) => {
//   const [leaders, setLeaders] = useState([]);
//   const [expandedTypes, setExpandedTypes] = useState({});
//   const [hoveredCardId, setHoveredCardId] = useState(null);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const [currentPage, setCurrentPage] = useState(1);

//   const [tLeaderFields, setTLeaderFields] = useState({}); // translations per leader
//   const [tTypeLabels, setTTypeLabels] = useState({});     // translations per type

//   const navigate = useNavigate();
//   const lang = selectedLang || localStorage.getItem("selectedLang") || "en";

//   useEffect(() => {
//     axios
//       .get("https://lcoiapi.emedha.in/appi/international_leaders")
//       .then((res) => setLeaders(res.data))
//       .catch((err) => console.error("API Error:", err));

//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // 🔁 Translations overlay
//   useEffect(() => {
//     let cancelled = false;
//     async function buildTranslations() {
//       if (!lang || lang === "en") {
//         if (!cancelled) {
//           setTLeaderFields({});
//           setTTypeLabels({});
//         }
//         return;
//       }

//       const entries = await Promise.all(
//         (leaders || []).map(async (ldr) => {
//           const out = {};
//           if (ldr.name) out.name = await translateText(String(ldr.name), lang);
//           if (ldr.designation) out.designation = await translateText(String(ldr.designation), lang);
//           if (ldr.club) out.club = await translateText(String(ldr.club), lang);
//           return [ldr.id, out];
//         })
//       );

//       const typeSet = new Set((leaders || []).map((l) => l.international_type || "Unknown"));
//       const typePairs = await Promise.all(
//         Array.from(typeSet).map(async (type) => {
//           const t = await translateText(String(type), lang);
//           return [type, t];
//         })
//       );

//       if (!cancelled) {
//         setTLeaderFields(Object.fromEntries(entries));
//         setTTypeLabels(Object.fromEntries(typePairs));
//       }
//     }

//     buildTranslations();
//     return () => { cancelled = true; };
//   }, [lang, leaders]);

//   // Group leaders by type
//   const groupedLeaders = leaders.reduce((acc, leader) => {
//     const type = leader.international_type || "Unknown";
//     if (!acc[type]) acc[type] = [];
//     acc[type].push(leader);
//     return acc;
//   }, {});

//   const typeNames = Object.keys(groupedLeaders);

//   // Paginated members per expanded type
//   const currentMembers = (type) => {
//     const members = groupedLeaders[type] || [];
//     if (!expandedTypes[type]) return [];
//     return members.slice((currentPage - 1) * CARDS_PER_PAGE, currentPage * CARDS_PER_PAGE);
//   };

//   const totalPages = (type) => {
//     const members = groupedLeaders[type] || [];
//     return Math.ceil(members.length / CARDS_PER_PAGE);
//   };

//   // Styles (same as Indiadirectory)
//   const containerStyle = { padding: "2rem", fontFamily: "Arial, sans-serif", maxWidth: "1000px", margin: "0 auto" };
//   const typeHeaderStyle = { display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "#f0f0f0", padding: "12px 16px", cursor: "pointer", borderRadius: "8px", marginBottom: "10px", fontWeight: "bold", fontSize: "16px" };
//   const cardsContainerStyle = { display: "flex", flexWrap: "wrap", gap: "20px", padding: "10px 0 30px 0", justifyContent: windowWidth < 768 ? "center" : "space-between" };
//   const cardStyle = (isHovered) => ({ display: "flex", flexDirection: "row", alignItems: "center", backgroundColor: "#fff", borderRadius: "10px", padding: "15px", boxShadow: isHovered ? "0 8px 16px rgba(0,0,0,0.2)" : "0 4px 8px rgba(0,0,0,0.1)", transition: "box-shadow 0.3s ease, transform 0.3s ease", transform: isHovered ? "translateY(-4px)" : "none", position: "relative", flex: windowWidth < 768 ? "1 1 100%" : "1 1 48%", maxWidth: windowWidth < 768 ? "100%" : "48%", flexWrap: "wrap" });
//   const imageWrapperStyle = { width: "60px", height: "60px", borderRadius: "50%", overflow: "hidden", backgroundColor: "#ddd", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 };
//   const imageStyle = { width: "50px", height: "100px", objectFit: "contain" };
//   const contentStyle = { flexGrow: 1, marginLeft: "20px", minWidth: "200px" };
//   const nameStyle = { margin: "0 0 5px 0", fontSize: "18px", fontWeight: "bold" };
//   const infoStyle = { margin: "4px 0", color: "#333", fontSize: "14px" };
//   const clubStyle = { marginTop: "12px", fontStyle: "italic", color: "#007bff", fontSize: "13px", width: "100%", borderTop: "1px solid #e0e0e0", paddingTop: "8px", textAlign: "center" };
//   const paginationContainer = { marginTop: "30px", textAlign: "center" };
//   const paginationButton = (active) => ({ margin: "0 5px", padding: "8px 12px", fontSize: "14px", borderRadius: "6px", border: "1px solid #007bff", backgroundColor: active ? "#007bff" : "#fff", color: active ? "#fff" : "#007bff", cursor: "pointer", transition: "all 0.2s ease" });
//   const backButtonStyle = { marginBottom: "20px", padding: "8px 14px", backgroundColor: "#007bff", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer" };

//   const toggleType = (type) => setExpandedTypes((prev) => ({ ...prev, [type]: !prev[type] }));

//   const convertImageToBase64 = (url) => {
//     return new Promise((resolve) => {
//       const img = new Image();
//       img.crossOrigin = "Anonymous";
//       img.onload = () => {
//         const canvas = document.createElement("canvas");
//         canvas.width = img.naturalWidth;
//         canvas.height = img.naturalHeight;
//         const ctx = canvas.getContext("2d");
//         ctx.drawImage(img, 0, 0);
//         resolve(canvas.toDataURL("image/png"));
//       };
//       img.onerror = () => resolve(null);
//       img.src = url;
//     });
//   };

//   const handleDownloadPDF = async (type) => {
//     const selected = groupedLeaders[type] || [];
//     const leadersWithBase64 = await Promise.all(
//       selected.map(async (leader) => {
//         const base64Image = leader.image ? await convertImageToBase64(leader.image) : null;
//         return { ...leader, image: base64Image };
//       })
//     );
//     const blob = await pdf(<InternationalPDFDocument type={type} leaders={leadersWithBase64} />).toBlob();
//     saveAs(blob, `${type.replace(/\s+/g, "_")}.pdf`);
//   };

//   const handleNavigate = () => navigate("/leadersPage");


//   const [translated, setTranslated] = useState({
//     InternationalLeaders: "",
//     BacktoDirectory: "",
//     DownloadPDF: "",
//     Year: "",

//   });

//   useEffect(() => {
//     async function translateAll() {
//       const englishTexts = {
//         InternationalLeaders: "International Leaders",
//         BacktoDirectory: " Back to Directory",
//         DownloadPDF: "Download PDF",
//         Year: "Year",
//       };



//       setTranslated({
//         InternationalLeaders: await translateText(englishTexts.InternationalLeaders, selectedLang),
//         BacktoDirectory: await translateText(englishTexts.BacktoDirectory, selectedLang),
//         DownloadPDF: await translateText(englishTexts.DownloadPDF, selectedLang),
//         Year: await translateText(englishTexts.Year, selectedLang),

//       });
//     }

//     translateAll();
//   }, [selectedLang]);


//   return (
//     <div style={containerStyle}>
//       <h4>{translated.InternationalLeaders}</h4>
//       <button style={backButtonStyle} onClick={handleNavigate}>
//         ← {translated.BacktoDirectory}
//       </button>

//       {typeNames.map((type) => (
//         <div key={type}>
//           <div style={typeHeaderStyle} onClick={() => toggleType(type)}>
//             <span>{tTypeLabels[type] || type}</span>
//             {expandedTypes[type] && (
//               <button style={{ marginLeft: 10, cursor: "pointer", backgroundColor: "#007bff", color: "#fff", border: "none", borderRadius: "4px", padding: "6px 10px" }}onClick={(e) => { e.stopPropagation(); handleDownloadPDF(type); }}>
//                 📄<FaArrowDown />{translated.DownloadPDF}
//               </button>
//             )}
//           </div>

//           {expandedTypes[type] && (
//             <>
//               <div style={cardsContainerStyle}>
//                 {currentMembers(type).map((leader) => {
//                   const isHovered = hoveredCardId === leader.id;
//                   const t = tLeaderFields[leader.id] || {};
//                   return (
//                     <div
//                       key={leader.id}
//                       style={cardStyle(isHovered)}
//                       onMouseEnter={() => setHoveredCardId(leader.id)}
//                       onMouseLeave={() => setHoveredCardId(null)}
//                     >
//                       <div style={imageWrapperStyle}>
//                         {leader.image ? (
//                           <img src={leader.image} alt={leader.name} style={imageStyle} />
//                         ) : (
//                           <FaUserCircle style={{ fontSize: "60px", color: "#aaa" }} />
//                         )}
//                       </div>

//                       <div style={contentStyle}>
//                         <h3 style={nameStyle}>{t.name || leader.name || "Not Available"}</h3>
//                         <p style={infoStyle}>{t.designation || leader.designation}</p>
//                         <p style={infoStyle}>
//                           <strong>{translated.Year}:</strong> {leader.year}
//                         </p>
//                         <div style={clubStyle}>{t.club || leader.club || "Club not available"}</div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>

//               {totalPages(type) > 1 && (
//                 <div style={paginationContainer}>
//                   {Array.from({ length: totalPages(type) }, (_, i) => (
//                     <button key={i + 1} style={paginationButton(currentPage === i + 1)} onClick={() => setCurrentPage(i + 1)}>
//                       {i + 1}
//                     </button>
//                   ))}
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default InternationalLeaders;

















// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { FaUserCircle } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { pdf } from "@react-pdf/renderer";
// import { saveAs } from "file-saver";
// import InternationalPDFDocument from "./InternationalPDFDocument";
// import { translateText } from "../Navbar/Navbar"; // same translator as Indiadirectory
// import { FaArrowDown } from "react-icons/fa";
// const CARDS_PER_PAGE = 16;

// const InternationalLeaders = ({ selectedLang }) => {
//   const [leaders, setLeaders] = useState([]);
//   const [expandedTypes, setExpandedTypes] = useState({});
//   const [hoveredCardId, setHoveredCardId] = useState(null);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const [currentPage, setCurrentPage] = useState(1);

//   const [tLeaderFields, setTLeaderFields] = useState({}); // translations per leader
//   const [tTypeLabels, setTTypeLabels] = useState({});     // translations per type

//   const navigate = useNavigate();
//   const lang = selectedLang || localStorage.getItem("selectedLang") || "en";

//   useEffect(() => {
//     axios
//       .get("https://lcoiapi.emedha.in/appi/international_leaders")
//       .then((res) => setLeaders(res.data))
//       .catch((err) => console.error("API Error:", err));

//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // 🔁 Translations overlay
//   useEffect(() => {
//     let cancelled = false;
//     async function buildTranslations() {
//       if (!lang || lang === "en") {
//         if (!cancelled) {
//           setTLeaderFields({});
//           setTTypeLabels({});
//         }
//         return;
//       }

//       const entries = await Promise.all(
//         (leaders || []).map(async (ldr) => {
//           const out = {};
//           if (ldr.name) out.name = await translateText(String(ldr.name), lang);
//           if (ldr.designation) out.designation = await translateText(String(ldr.designation), lang);
//           if (ldr.club) out.club = await translateText(String(ldr.club), lang);
//           return [ldr.id, out];
//         })
//       );

//       const typeSet = new Set((leaders || []).map((l) => l.international_type || "Unknown"));
//       const typePairs = await Promise.all(
//         Array.from(typeSet).map(async (type) => {
//           const t = await translateText(String(type), lang);
//           return [type, t];
//         })
//       );

//       if (!cancelled) {
//         setTLeaderFields(Object.fromEntries(entries));
//         setTTypeLabels(Object.fromEntries(typePairs));
//       }
//     }

//     buildTranslations();
//     return () => { cancelled = true; };
//   }, [lang, leaders]);

//   // Group leaders by type
//   const groupedLeaders = leaders.reduce((acc, leader) => {
//     const type = leader.international_type || "Unknown";
//     if (!acc[type]) acc[type] = [];
//     acc[type].push(leader);
//     return acc;
//   }, {});

//   const typeNames = Object.keys(groupedLeaders);

//   // Paginated members per expanded type
//   const currentMembers = (type) => {
//     const members = groupedLeaders[type] || [];
//     if (!expandedTypes[type]) return [];
//     return members.slice((currentPage - 1) * CARDS_PER_PAGE, currentPage * CARDS_PER_PAGE);
//   };

//   const totalPages = (type) => {
//     const members = groupedLeaders[type] || [];
//     return Math.ceil(members.length / CARDS_PER_PAGE);
//   };

//   // Styles (same as Indiadirectory)
//   const containerStyle = { padding: "2rem", fontFamily: "Arial, sans-serif", maxWidth: "1000px", margin: "0 auto" };
//   const typeHeaderStyle = { display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "#f0f0f0", padding: "12px 16px", cursor: "pointer", borderRadius: "8px", marginBottom: "10px", fontWeight: "bold", fontSize: "16px" };
//   const cardsContainerStyle = { display: "flex", flexWrap: "wrap", gap: "20px", padding: "10px 0 30px 0", justifyContent: windowWidth < 768 ? "center" : "space-between" };
//   const cardStyle = (isHovered) => ({ display: "flex", flexDirection: "row", alignItems: "center", backgroundColor: "#fff", borderRadius: "10px", padding: "15px", boxShadow: isHovered ? "0 8px 16px rgba(0,0,0,0.2)" : "0 4px 8px rgba(0,0,0,0.1)", transition: "box-shadow 0.3s ease, transform 0.3s ease", transform: isHovered ? "translateY(-4px)" : "none", position: "relative", flex: windowWidth < 768 ? "1 1 100%" : "1 1 48%", maxWidth: windowWidth < 768 ? "100%" : "48%", flexWrap: "wrap" });
//   const imageWrapperStyle = { width: "60px", height: "60px", borderRadius: "50%", overflow: "hidden", backgroundColor: "#ddd", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 };
//   const imageStyle = { width: "50px", height: "100px", objectFit: "contain" };
//   const contentStyle = { flexGrow: 1, marginLeft: "20px", minWidth: "200px" };
//   const nameStyle = { margin: "0 0 5px 0", fontSize: "18px", fontWeight: "bold" };
//   const infoStyle = { margin: "4px 0", color: "#333", fontSize: "14px" };
//   const clubStyle = { marginTop: "12px", fontStyle: "italic", color: "#007bff", fontSize: "13px", width: "100%", borderTop: "1px solid #e0e0e0", paddingTop: "8px", textAlign: "center" };
//   const paginationContainer = { marginTop: "30px", textAlign: "center" };
//   const paginationButton = (active) => ({ margin: "0 5px", padding: "8px 12px", fontSize: "14px", borderRadius: "6px", border: "1px solid #007bff", backgroundColor: active ? "#007bff" : "#fff", color: active ? "#fff" : "#007bff", cursor: "pointer", transition: "all 0.2s ease" });
//   const backButtonStyle = { marginBottom: "20px", padding: "8px 14px", backgroundColor: "#007bff", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer", marginRight: "10px" };
//   const globalDownloadButtonStyle = { marginBottom: "20px", padding: "8px 14px", backgroundColor: "#28a745", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer" };

//   const toggleType = (type) => setExpandedTypes((prev) => ({ ...prev, [type]: !prev[type] }));

//   const convertImageToBase64 = (url) => {
//     return new Promise((resolve) => {
//       const img = new Image();
//       img.crossOrigin = "Anonymous";
//       img.onload = () => {
//         const canvas = document.createElement("canvas");
//         canvas.width = img.naturalWidth;
//         canvas.height = img.naturalHeight;
//         const ctx = canvas.getContext("2d");
//         ctx.drawImage(img, 0, 0);
//         resolve(canvas.toDataURL("image/png"));
//       };
//       img.onerror = () => resolve(null);
//       img.src = url;
//     });
//   };

//   // Modified to handle ALL leaders combined into a single PDF
//   const handleDownloadAllPDF = async () => {
//     const leadersWithBase64 = await Promise.all(
//       leaders.map(async (leader) => {
//         const base64Image = leader.image ? await convertImageToBase64(leader.image) : null;
//         return { ...leader, image: base64Image };
//       })
//     );
//     const blob = await pdf(<InternationalPDFDocument type="All International Leaders" leaders={leadersWithBase64} />).toBlob();
//     saveAs(blob, "All_International_Leaders.pdf");
//   };

//   const handleNavigate = () => navigate("/leadersPage");

//   const [translated, setTranslated] = useState({
//     InternationalLeaders: "",
//     BacktoDirectory: "",
//     DownloadPDF: "",
//     Year: "",
//     DownloadAllPDF: "",
//   });

//   useEffect(() => {
//     async function translateAll() {
//       const englishTexts = {
//         InternationalLeaders: "International Leaders",
//         BacktoDirectory: " Back to Directory",
//         DownloadPDF: "Download PDF",
//         Year: "Year",
//         DownloadAllPDF: "International Leaders PDF",
//       };

//       setTranslated({
//         InternationalLeaders: await translateText(englishTexts.InternationalLeaders, selectedLang),
//         BacktoDirectory: await translateText(englishTexts.BacktoDirectory, selectedLang),
//         DownloadPDF: await translateText(englishTexts.DownloadPDF, selectedLang),
//         Year: await translateText(englishTexts.Year, selectedLang),
//         DownloadAllPDF: await translateText(englishTexts.DownloadAllPDF, selectedLang),
//       });
//     }

//     translateAll();
//   }, [selectedLang]);

//   return (
//     <div style={containerStyle}>
//       <h4>{translated.InternationalLeaders}</h4>
//       <div>
//         <button style={backButtonStyle} onClick={handleNavigate}>
//           ← {translated.BacktoDirectory}
//         </button>
//         <button style={globalDownloadButtonStyle} onClick={handleDownloadAllPDF}>
//           📄<FaArrowDown /> {translated.DownloadAllPDF || "Download All PDF"}
//         </button>
//       </div>

//       {typeNames.map((type) => (
//         <div key={type}>
//           <div style={typeHeaderStyle} onClick={() => toggleType(type)}>
//             <span>{tTypeLabels[type] || type}</span>
//             {/* Individual download button removed from here */}
//           </div>

//           {expandedTypes[type] && (
//             <>
//               <div style={cardsContainerStyle}>
//                 {currentMembers(type).map((leader) => {
//                   const isHovered = hoveredCardId === leader.id;
//                   const t = tLeaderFields[leader.id] || {};
//                   return (
//                     <div
//                       key={leader.id}
//                       style={cardStyle(isHovered)}
//                       onMouseEnter={() => setHoveredCardId(leader.id)}
//                       onMouseLeave={() => setHoveredCardId(null)}
//                     >
//                       <div style={imageWrapperStyle}>
//                         {leader.image ? (
//                           <img src={leader.image} alt={leader.name} style={imageStyle} />
//                         ) : (
//                           <FaUserCircle style={{ fontSize: "60px", color: "#aaa" }} />
//                         )}
//                       </div>

//                       <div style={contentStyle}>
//                         <h3 style={nameStyle}>{t.name || leader.name || "Not Available"}</h3>
//                         <p style={infoStyle}>{t.designation || leader.designation}</p>
//                         <p style={infoStyle}>
//                           <strong>{translated.Year}:</strong> {leader.year}
//                         </p>
//                         <div style={clubStyle}>{t.club || leader.club || "Club not available"}</div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>

//               {totalPages(type) > 1 && (
//                 <div style={paginationContainer}>
//                   {Array.from({ length: totalPages(type) }, (_, i) => (
//                     <button key={i + 1} style={paginationButton(currentPage === i + 1)} onClick={() => setCurrentPage(i + 1)}>
//                       {i + 1}
//                     </button>
//                   ))}
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default InternationalLeaders;



import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaUserCircle, FaArrowDown, FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import InternationalPDFDocument from "./InternationalPDFDocument";
import { translateText } from "../Navbar/Navbar";

const CARDS_PER_PAGE = 16;

const InternationalLeaders = ({ selectedLang }) => {
  const [leaders, setLeaders] = useState([]);
  const [expandedTypes, setExpandedTypes] = useState({});
  const [hoveredCardId, setHoveredCardId] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [currentPage, setCurrentPage] = useState(1);

  const [tLeaderFields, setTLeaderFields] = useState({});
  const [tTypeLabels, setTTypeLabels] = useState({});

  const navigate = useNavigate();
  const lang = selectedLang || localStorage.getItem("selectedLang") || "en";

  useEffect(() => {
    axios
      .get("https://lcoiapi.emedha.in/appi/international_leaders")
      .then((res) => setLeaders(res.data))
      .catch((err) => console.error("API Error:", err));

    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    let cancelled = false;
    async function buildTranslations() {
      if (!lang || lang === "en") {
        if (!cancelled) {
          setTLeaderFields({});
          setTTypeLabels({});
        }
        return;
      }

      const entries = await Promise.all(
        (leaders || []).map(async (ldr) => {
          const out = {};
          if (ldr.name) out.name = await translateText(String(ldr.name), lang);
          if (ldr.designation) out.designation = await translateText(String(ldr.designation), lang);
          if (ldr.club) out.club = await translateText(String(ldr.club), lang);
          return [ldr.id, out];
        })
      );

      const typeSet = new Set((leaders || []).map((l) => l.international_type || "Unknown"));
      const typePairs = await Promise.all(
        Array.from(typeSet).map(async (type) => {
          const t = await translateText(String(type), lang);
          return [type, t];
        })
      );

      if (!cancelled) {
        setTLeaderFields(Object.fromEntries(entries));
        setTTypeLabels(Object.fromEntries(typePairs));
      }
    }

    buildTranslations();
    return () => { cancelled = true; };
  }, [lang, leaders]);

  const groupedLeaders = leaders.reduce((acc, leader) => {
    const type = leader.international_type || "Unknown";
    if (!acc[type]) acc[type] = [];
    acc[type].push(leader);
    return acc;
  }, {});

  const typeNames = Object.keys(groupedLeaders);

  const currentMembers = (type) => {
    const members = groupedLeaders[type] || [];
    if (!expandedTypes[type]) return [];
    return members.slice((currentPage - 1) * CARDS_PER_PAGE, currentPage * CARDS_PER_PAGE);
  };

  const totalPages = (type) => {
    const members = groupedLeaders[type] || [];
    return Math.ceil(members.length / CARDS_PER_PAGE);
  };

  const toggleType = (type) => setExpandedTypes((prev) => ({ ...prev, [type]: !prev[type] }));

  const convertImageToBase64 = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = () => resolve(null);
      img.src = url;
    });
  };

  const handleDownloadAllPDF = async () => {
    const leadersWithBase64 = await Promise.all(
      leaders.map(async (leader) => {
        const base64Image = leader.image ? await convertImageToBase64(leader.image) : null;
        return { ...leader, image: base64Image };
      })
    );
    const blob = await pdf(<InternationalPDFDocument type="All International Leaders" leaders={leadersWithBase64} />).toBlob();
    saveAs(blob, "All_International_Leaders.pdf");
  };

  const handleDownloadPDF = async (type) => {
    const selected = groupedLeaders[type] || [];
    const leadersWithBase64 = await Promise.all(
      selected.map(async (leader) => {
        const base64Image = leader.image ? await convertImageToBase64(leader.image) : null;
        return { ...leader, image: base64Image };
      })
    );
    const blob = await pdf(<InternationalPDFDocument type={type} leaders={leadersWithBase64} />).toBlob();
    saveAs(blob, `${type.replace(/\s+/g, "_")}.pdf`);
  };

  const handleNavigate = () => navigate("/leadersPage");

  const [translated, setTranslated] = useState({
    InternationalLeaders: "",
    BacktoDirectory: "",
    DownloadPDF: "",
    Year: "",
    DownloadAllPDF: "",
  });

  useEffect(() => {
    async function translateAll() {
      const englishTexts = {
        InternationalLeaders: "International Leaders",
        BacktoDirectory: "Back to Directory",
        DownloadPDF: "Download PDF",
        Year: "Year",
        DownloadAllPDF: "Download All PDF",
      };

      setTranslated({
        InternationalLeaders: await translateText(englishTexts.InternationalLeaders, selectedLang),
        BacktoDirectory: await translateText(englishTexts.BacktoDirectory, selectedLang),
        DownloadPDF: await translateText(englishTexts.DownloadPDF, selectedLang),
        Year: await translateText(englishTexts.Year, selectedLang),
        DownloadAllPDF: await translateText(englishTexts.DownloadAllPDF, selectedLang),
      });
    }

    translateAll();
  }, [selectedLang]);

  return (
    <div style={{ padding: windowWidth < 768 ? "1rem" : "2.5rem 2rem", fontFamily: "'Inter', system-ui, -apple-system, sans-serif", maxWidth: "1200px", margin: "0 auto", backgroundColor: "#f8fafc", minHeight: "100vh", color: "#1e293b" }}>
      
      {/* Header Section */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "15px", marginBottom: "2rem", borderBottom: "1px solid #e2e8f0", paddingBottom: "1.5rem" }}>
        <h2 style={{ margin: 0, fontSize: windowWidth < 768 ? "20px" : "26px", fontWeight: "700", color: "#0f172a" }}>
          {translated.InternationalLeaders || "International Leaders"}
        </h2>
        
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          <button 
            style={{ display: "flex", alignItems: "center", gap: "6px", padding: "10px 16px", backgroundColor: "#ffffff", color: "#475569", border: "1px solid #cbd5e1", borderRadius: "8px", fontWeight: "600", fontSize: "14px", cursor: "pointer", transition: "all 0.2s ease", boxShadow: "0 1px 2px rgba(0,0,0,0.05)" }} 
            onClick={handleNavigate}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#f1f5f9"}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#ffffff"}
          >
            ← {translated.BacktoDirectory || "Back to Directory"}
          </button>
          
          <button 
            style={{ display: "flex", alignItems: "center", gap: "6px", padding: "10px 16px", backgroundColor: "#0284c7", color: "#ffffff", border: "none", borderRadius: "8px", fontWeight: "600", fontSize: "14px", cursor: "pointer", transition: "all 0.2s ease", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }} 
            onClick={handleDownloadAllPDF}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#0369a1"}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#0284c7"}
          >
            <FaArrowDown /> {translated.DownloadAllPDF || "Download All PDF"}
          </button>
        </div>
      </div>

      {/* Accordion / Category Sections */}
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {typeNames.map((type) => {
          const isExpanded = expandedTypes[type];
          return (
            <div key={type} style={{ backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.04)", overflow: "hidden", transition: "all 0.2s ease" }}>
              
              {/* Category Header */}
              <div 
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px", cursor: "pointer", backgroundColor: isExpanded ? "#f8fafc" : "#ffffff", borderBottom: isExpanded ? "1px solid #e2e8f0" : "none" }} 
                onClick={() => toggleType(type)}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <FaChevronRight style={{ fontSize: "12px", color: "#64748b", transform: isExpanded ? "rotate(90deg)" : "none", transition: "transform 0.2s ease" }} />
                  <span style={{ fontWeight: "600", fontSize: "16px", color: "#334155" }}>
                    {tTypeLabels[type] || type}
                  </span>
                  <span style={{ fontSize: "12px", backgroundColor: "#e2e8f0", color: "#475569", padding: "2px 8px", borderRadius: "12px", fontWeight: "500" }}>
                    {groupedLeaders[type]?.length || 0}
                  </span>
                </div>

                {isExpanded && (
                  <button 
                    style={{ display: "flex", alignItems: "center", gap: "6px", backgroundColor: "#f0fdf4", color: "#16a34a", border: "1px solid #dcfce7", borderRadius: "6px", padding: "6px 12px", fontSize: "13px", fontWeight: "600", cursor: "pointer", transition: "background 0.2s" }}
                    onClick={(e) => { 
                      e.stopPropagation(); 
                      handleDownloadPDF(type); 
                    }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#dcfce7"}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#f0fdf4"}
                  >
                    <FaArrowDown /> {translated.DownloadPDF || "Download PDF"}
                  </button>
                )}
              </div>

              {/* Members Cards Grid */}
              {isExpanded && (
                <div style={{ padding: "20px" }}>
                  <div style={{ display: "grid", gridTemplateColumns: windowWidth < 768 ? "1fr" : "repeat(auto-fill, minmax(310px, 1fr))", gap: "20px" }}>
                    {currentMembers(type).map((leader) => {
                      const isHovered = hoveredCardId === leader.id;
                      const t = tLeaderFields[leader.id] || {};
                      return (
                        <div
                          key={leader.id}
                          style={{ display: "flex", flexDirection: "row", alignItems: "center", backgroundColor: "#ffffff", borderRadius: "10px", padding: "16px", border: "1px solid #e2e8f0", boxShadow: isHovered ? "0 10px 15px -3px rgba(0, 0, 0, 0.08)" : "0 1px 3px rgba(0,0,0,0.02)", transition: "all 0.2s ease", transform: isHovered ? "translateY(-2px)" : "none" }}
                          onMouseEnter={() => setHoveredCardId(leader.id)}
                          onMouseLeave={() => setHoveredCardId(null)}
                        >
                          <div style={{ width: "64px", height: "64px", borderRadius: "50%", overflow: "hidden", backgroundColor: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, border: "1px solid #e2e8f0" }}>
                            {leader.image ? (
                              <img src={leader.image} alt={leader.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            ) : (
                              <FaUserCircle style={{ fontSize: "50px", color: "#cbd5e1" }} />
                            )}
                          </div>

                          <div style={{ flexGrow: 1, marginLeft: "16px", minWidth: 0 }}>
                            <h3 style={{ margin: "0 0 4px 0", fontSize: "16px", fontWeight: "600", color: "#0f172a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              {t.name || leader.name || "Not Available"}
                            </h3>
                            <p style={{ margin: "0 0 4px 0", color: "#475569", fontSize: "13px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              {t.designation || leader.designation}
                            </p>
                            <p style={{ margin: "0 0 8px 0", color: "#64748b", fontSize: "12px" }}>
                              <strong>{translated.Year || "Year"}:</strong> {leader.year}
                            </p>
                            <div style={{ fontSize: "12px", fontStyle: "italic", color: "#0284c7", borderTop: "1px solid #f1f5f9", paddingTop: "6px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              {t.club || leader.club || "Club not available"}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* Pagination */}
                  {totalPages(type) > 1 && (
                    <div style={{ display: "flex", justifyContent: "center", gap: "6px", marginTop: "24px" }}>
                      {Array.from({ length: totalPages(type) }, (_, i) => (
                        <button 
                          key={i + 1} 
                          style={{ padding: "6px 12px", fontSize: "13px", fontWeight: "600", borderRadius: "6px", border: currentPage === i + 1 ? "1px solid #0284c7" : "1px solid #cbd5e1", backgroundColor: currentPage === i + 1 ? "#0284c7" : "#ffffff", color: currentPage === i + 1 ? "#ffffff" : "#475569", cursor: "pointer", transition: "all 0.2s" }} 
                          onClick={() => setCurrentPage(i + 1)}
                        >
                          {i + 1}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InternationalLeaders;